import { useState } from 'react';
import { AppBar, Box, Toolbar, Container, Theme } from '@mui/material';
import { Logo, AccountMenu } from '@carcareers/components';

import AppbarDrawer from './AppbarDrawer';
import AppbarNoAuth from './AppbarNoAuth';
import AppbarJobseekerAuth from './AppbarJobseekerAuth';

export const Appbar = () => {
  const [isOpenDrawer, setOpenDrawer] = useState<boolean>(false);

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={(theme: Theme) => ({
        backgroundColor: theme.palette.background.default,
        boxShadow: '1px 1px 1px 1px rgba(0, 0, 0, 0.1)',
      })}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Logo isMobile={false} isOpenDrawer={isOpenDrawer} />
          <AppbarDrawer isOpen={isOpenDrawer} setOpen={setOpenDrawer} />
          <Logo isMobile={true} isOpenDrawer={isOpenDrawer} />
          <AppbarNoAuth />
          <AppbarJobseekerAuth />
          <Box sx={{ flexGrow: 0 }}>
            <AccountMenu />
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Appbar;
